import { render, staticRenderFns } from "./shopPlanheader.vue?vue&type=template&id=764c1e24&scoped=true"
import script from "./shopPlanheader.vue?vue&type=script&lang=js"
export * from "./shopPlanheader.vue?vue&type=script&lang=js"
import style0 from "./shopPlanheader.vue?vue&type=style&index=0&id=764c1e24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764c1e24",
  null
  
)

export default component.exports